import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { toast } from 'sonner';
import { changePasswordSchema } from '@solar/shared';
import { api, errorMessage } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Field } from '@/components/ui/field';

const schema = changePasswordSchema
  .extend({ confirm: z.string() })
  .refine((v) => v.newPassword === v.confirm, { message: 'Mật khẩu nhập lại không khớp', path: ['confirm'] });

export function ChangePasswordForm({ onDone }: { onDone?: () => void }) {
  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: { currentPassword: '', newPassword: '', confirm: '' },
  });
  const e = form.formState.errors;
  const submit = form.handleSubmit(async (v) => {
    try {
      await api.post('/auth/change-password', {
        currentPassword: v.currentPassword,
        newPassword: v.newPassword,
      });
      toast.success('Đã đổi mật khẩu. Các phiên đăng nhập khác đã bị đăng xuất.');
      form.reset();
      onDone?.();
    } catch (err) {
      toast.error(errorMessage(err));
    }
  });
  return (
    <form onSubmit={submit} className="space-y-4" noValidate>
      <Field label="Mật khẩu hiện tại" htmlFor="cp" error={e.currentPassword?.message}>
        <Input
          id="cp"
          type="password"
          autoComplete="current-password"
          {...form.register('currentPassword')}
        />
      </Field>
      <Field
        label="Mật khẩu mới"
        htmlFor="np"
        error={e.newPassword?.message}
        hint="Tối thiểu 8 ký tự, gồm chữ hoa, chữ thường và chữ số"
      >
        <Input id="np" type="password" autoComplete="new-password" {...form.register('newPassword')} />
      </Field>
      <Field label="Nhập lại mật khẩu mới" htmlFor="np2" error={e.confirm?.message}>
        <Input id="np2" type="password" autoComplete="new-password" {...form.register('confirm')} />
      </Field>
      <Button type="submit" loading={form.formState.isSubmitting}>
        Đổi mật khẩu
      </Button>
    </form>
  );
}
